<li>
  <a i18n="@@Login" class="user button button-primary mr-2" (click)="login()"
    >Login</a
  >
</li>
<li>
  <a
    i18n="@@Register"
    class="user button button-primary mr-2"
    (click)="login(true)"
    >Register</a
  >
</li>
